import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './OpportunityPlannerAdminControls.scss';

import { getBasicBrands } from '../../../APIClient/brands';

import ShopMySelect from '../../General/ShopMySelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';

const OpportunityPlannerAdminControls = props => {
  const { overridePlannerBrand, setOverridePlannerBrand } = props;

  const [brands, setBrands] = React.useState([]);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const toggleExpanded = () => setIsExpanded(!isExpanded);

  React.useEffect(() => {
    getBasicBrands().then(brands => {
      setBrands(brands);
    });
  }, []);
  return (
    <div className={cn('opportunity-planner-admin-controls', { expanded: isExpanded })}>
      <div onClick={toggleExpanded} className='header-container'>
        <div className='header'>Admin Controls</div>
        <div className='subheader'>Advanced controls to help build your opportunity alongside your brand partner.</div>
        <div className='expand-icon'>
          <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} />
        </div>
      </div>
      {isExpanded && (
        <div className='controls-container'>
          <div className='control'>
            <div className='control-header-container'>
              <div className='control-header'>Brand to use for Planning</div>
              <div className='control-subheader'>
                Select the brand you want to use for planning. This allows you to help brands with less data by using a dataset from another brand.
              </div>
            </div>
            <div className='value'>
              <ShopMySelect
                noStyling
                isNewSmallerStyling
                options={brands.map(brand => ({
                  value: brand.id,
                  label: brand.name
                }))}
                value={overridePlannerBrand?.id}
                onChangeValue={value => setOverridePlannerBrand(brands.find(brand => brand.id === value))}
                placeholder={`Select one of ${brands.length} brands`}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

OpportunityPlannerAdminControls.propTypes = {
  overridePlannerBrand: PropTypes.object,
  setOverridePlannerBrand: PropTypes.func
};

export default OpportunityPlannerAdminControls;
